const removeCartItem = async (itemId) => {
  const itemUpdates = {
    "id": itemId+"",
    "quantity": 0
  }
  const removeItemRquest = await fetch(window.routes.cart_change_url+".js",{
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify( itemUpdates )
  }).then(response => {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
const checkInsurance = async () => {
  const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const cartRequest = await fetch(window.routes.cart_url+".json",{
    method: 'GET'
  });
  const cart = await cartRequest.json();
  const cartTotal = cart.total_price;
  let addInsurance = false;
  const insurances = cart.items.filter((item) => Object.hasOwn(item.properties, '__insurance'));
  if(insurances.length < 1){
    addInsurance = true
  }
  for(let i = 0; i < insurances.length; i++){
    const item = insurances[i];
    // "insurance" already on cart checking max and min threshold
    const min_range = item.properties.__min * 100;
    const max_range = item.properties.__max * 100;
    if(cartTotal < min_range || (max_range > 0 && cartTotal > max_range)){
      // remove "insurance" from i
      removeCartItem(item.id)
      insurances.splice(i, 1);
    }
  }
  if(insurances.length < 1){
    addInsurance = true
  }
  if (addInsurance) {
    const requestInsurance = await fetch('/products/seguro?view=insurance',{method:'GET'});
    const insurance = await requestInsurance.json();
    if(insurance.id == ''){
      return;
    }
    let formData = {
     'items': [{
      'id': insurance.id,
      'quantity': 1,
       properties: {
          '__insurance': true,
          '__max': insurance.max_range,
          '__min': insurance.min_range,
        }
      }]
    };
    
    const requestAddItem = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}